<template>
    <AddressEditable :address="baseData.address"
                     :showStreetAndNr="showStreetAndNr"
                     :showZipCity="showZipCity"
                     :showPhone="showPhone"
                     :showEmail="showEmail"
                     :showCumulus="false"
                     :phoneOptional="phoneOptional"
                     @change="updateAddress" />

</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        props: {
            showStreetAndNr: {
                type: Boolean,
                default: true
            },
            showZipCity: {
                type: Boolean,
                default: true
            },
            showPhone: {
                type: Boolean,
                default: true
            },
            phoneOptional: {
                type: Boolean,
                default: false
            },
            showEmail: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            ...mapGetters([
                'baseData'
            ]),

        },
        methods: {
            updateAddress(normalizedAddress) {
                this.$store.commit('setAddress', normalizedAddress);
            }
        }
    };
</script>